import { type Bid, isBidAwarded } from 'loads/domain/Bid'
import { type LoadOffer } from 'loads/domain/LoadOffer'

export function getLoadPrice(bid: Nullable<Bid>, load: LoadOffer) {
  if (bid && isBidAwarded(bid)) return bid.price

  return load.activeOffer?.price
}
